import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface TooltipProps {
  children: ReactNode;
  content: string;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
  theme?: "light" | "dark";
  fixed?: boolean;
}

export function Tooltip({
  children,
  content,
  side = "bottom",
  className,
  theme = "dark",
}: TooltipProps) {
  // Position classes based on side
  const positionClasses = {
    top: "-top-8 left-1/2 -translate-x-1/2",
    bottom: "-bottom-8 left-1/2 -translate-x-1/2",
    left: "top-1/2 -translate-y-1/2 -left-2 -translate-x-full",
    right: "top-1/2 -translate-y-1/2 -right-2 translate-x-full",
  };

  return (
    <div className="relative inline-flex">
      <div className="peer">{children}</div>
      <span
        className={cn(
          `absolute px-2 py-1 text-xs rounded-md whitespace-nowrap ${theme === "light" ? "bg-white border border-gray-200 text-gray-700" : "bg-gray-800 border border-gray-700 text-gray-100"}`,
          "opacity-0 peer-hover:opacity-100 transition-opacity duration-200",
          "pointer-events-none z-[1000] shadow-lg",
          positionClasses[side],
          className
        )}
      >
        {content}
      </span>
    </div>
  );
}

// Simple wrapper for tooltip trigger elements
export function TooltipTrigger({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={className}>{children}</div>;
}
